import { UgcTab, TaskCallbackId } from "../typings";

export const taskText = [
  {
    key: "dailyLogin",
    titleKey: "taskDailyLoginTitle",
    descriptKey: "taskDailyLoginDesc",
    login: true,
  },
  {
    key: "downloadGame",
    titleKey: "taskReserveTitle",
    descriptKey: "taskReserveDesc",
    callbackKey: TaskCallbackId.GameDownload,
    redirectUrl: `https://gwww.gnjoy.hk/sea_official/index.html`,
  },
  {
    key: "provideFeedback",
    titleKey: "taskFeedbackTitle",
    descriptKey: "taskFeedbackDesc",
    feedbackPopup: true,
  },
  {
    key: "submitMyPoly",
    titleKey: "taskRoMemoryTitle",
    descriptKey: "taskRoMemoryDesc",
    ugcTab: UgcTab.UgcTypeMyPoring,
    autoOpen: true,
  },
  {
    key: "submitClassShow",
    titleKey: "taskCostumeTitle",
    descriptKey: "taskCostumeDesc",
    ugcTab: UgcTab.UgcTypeJobShare,
    autoOpen: true,
  },
  {
    key: "submitPhoto",
    titleKey: "taskPhotoTitle",
    descriptKey: "taskPhotoDesc",
    ugcTab: UgcTab.UgcTypePhoto,
    autoOpen: true,
  },
  {
    key: "likeOthersUgc",
    titleKey: "taskLikeOtherTitle",
    descriptKey: "taskLikeOtherDesc",
    ugcTab: UgcTab.UgcTypeMyPoring,
  },
  {
    key: "likeMyUgc",
    titleKey: "taskLikeMyTitle",
    descriptKey: "taskLikeMyDesc",
    centerTab: true,
  },
  {
    key: "joinFb",
    titleKey: "taskFbTitle",
    descriptKey: "taskFbDesc",
    callbackKey: TaskCallbackId.JoinFb,
    redirectUrl: `https://www.facebook.com/RagnarokTheNewWorld.Gravity`,
  },
  {
    key: "joinDc",
    titleKey: "taskDcTitle",
    descriptKey: "taskDcDesc",
    callbackKey: TaskCallbackId.JoinDc,
    redirectUrl: `https://discord.gg/ragnarokthenewworld`,
  },
  {
    key: "joinYtb",
    titleKey: "taskYtbTitle",
    descriptKey: "taskYtbDesc",
    callbackKey: TaskCallbackId.JoinYtb,
    redirectUrl: `https://www.youtube.com/@RagnarokTheNewWorld`,
  },
  {
    key: "joinLine",
    titleKey: "taskLineTitle",
    descriptKey: "taskLineDesc",
    callbackKey: TaskCallbackId.JoinLine,
    redirectUrl: `https://lin.ee/VOKACUF`,
  },
];

export const awardConfig = {
  Thanks: "awardThanks",
  Title: "awardTitle",
  Avatar: "awardAvatar",
  Headwear: "awardHeadwear",
  ScoreTitleLv1: "scoreTitleLv1",
  ScoreTitleLv2: "scoreTitleLv2",
  ScoreTitleLv3: "scoreTitleLv3",
  Blindbox: "awardBlindbox",
  Zeny: "awardZeny",
  Coin: "awardCoin",
  Doll: "awardDoll",
  Card: "awardCard",
  Tshirt: "awardTshirt",
  Backpack: "awardBackpack",
  Photocard: "awardPhotocard",
};
